(ns ui.components.input.password-input
  (:require
   [common.util :as cu]
   [frontend.utils :as fu]
   [ui.dom-globals :as dg]))

(defn view
  [{:keys [ref class value placeholder disabled? transparent? autocomplete on-change on-focus on-blur on-key-down variant]}]
  [:input
   (merge {:type          "password"
           :ref           (fn [input-ref]
                            (when (fn? ref)
                              (ref input-ref)))
           :class-name    (fu/cs "peer px-3 rounded placeholder-transparent focus:outline-none focus:ring-0 text-md"
                                 (if transparent?
                                   "bg-transparent disabled:bg-transparent"
                                   "text-input-light-text disabled:text-disabled-regular-text
                                    bg-input-light disabled:bg-disabled-regular")
                                 (if (not= variant :borderless)
                                   "py-2 border border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border"
                                   "py-2 border-none focus:border-transparent ")
                                 (when-not (cu/blank-value? value)
                                   "value")
                                 class)
           :value         (or value "")
           :placeholder   (or placeholder "")
           :auto-complete autocomplete
           :on-focus      (fn [_e]
                            (when (fn? on-focus)
                              (on-focus)))
           :on-blur       (fn [e]
                            (when (fn? on-blur)
                              (on-blur (dg/event-target-value e))))
           :on-key-down   (fn [e]
                            (when (fn? on-key-down)
                              (on-key-down e)))
           :on-change     (fn [e]
                            (when (fn? on-change)
                              (on-change (dg/event-target-value e))))}
          (when disabled?
            {:disabled true}))])
